import { renderPageShell } from '../lib/page-shell';
import { verifyEmail } from '../lib/session';
import type { RouteHandler } from '../lib/router';

export const renderVerifyEmail: RouteHandler = (container, navigate, query) => {
  const token = query.get('token');

  const body = renderPageShell(container, navigate, 'account', {
    title: 'VERIFY EMAIL',
    subtitle: '',
    body: `<div id="verify-mount"><p class="settings-hint">Verifying…</p></div>`,
  });

  const mount = body.querySelector<HTMLDivElement>('#verify-mount')!;

  if (!token) {
    mount.innerHTML = `<p class="settings-hint">This link is missing its token. Use the link from your email exactly as sent.</p>`;
    return;
  }

  verifyEmail(token)
    .then(() => {
      mount.innerHTML = `
        <p>Email verified. Ranked queue is unlocked.</p>
        <button class="button button--primary" type="button" data-action="account">Back to account</button>
      `;
      mount.querySelector<HTMLButtonElement>('[data-action="account"]')?.addEventListener('click', () => navigate('account'));
    })
    .catch((error: unknown) => {
      mount.innerHTML = `<p class="form-error" data-tone="error">${error instanceof Error ? error.message : 'That verification link is invalid or has expired.'}</p>`;
    });
};
